/*
 GENERATED FILE - DO NOT MODIFY
 Any changes will be overwritten when `yarn svgs` is executed.
 
 Generated from: assets/status.svg
 If you need to make changes the attributes, modify the original .svg file.
 
 If you need to modify the file further, consider copying this generated file to a new location,
 or into the component that uses it. If you do this, it might make sense to remove the original .svg file, 
 or it could be regenerated the next time SVGs are generated.
*/
import * as React from 'react';
const StatusIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef: any) => (
    <svg
      width={21}
      height={21}
      viewBox="0 0 21 21"
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <g fill="none" fillRule="evenodd">
        <path
          stroke="#343434"
          strokeWidth={2}
          d="M10.5 20c5.247 0 9.5-4.253 9.5-9.5S15.747 1 10.5 1 1 5.253 1 10.5 5.253 20 10.5 20z"
        />
        <path
          fill="#333"
          d="M9.75 12.018h1.5v-6.5h-1.5zm-.234 2.456a.985.985 0 111.969.003.985.985 0 01-1.969-.003"
        />
      </g>
    </svg>
  ),
);
export default StatusIcon;
